import { StarDavidIcon } from './StarDavidIcon';

/**
 * author: Nick
 * id 7EF95029-012C-456C-A1E8-BB96961071FD
 * name star-david
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-david.svg
 * tags
 * - Religion 
 */
export const JewishIcon = StarDavidIcon;
export default JewishIcon